<template>
  <!-- {{ item }} -->
  <div
    class="px-2.5 py-1.5 my-2 rounded-lg border-1 cursor-pointer transition-all hover:shadow-md border-gray-300 hover:border-customBlue-100 bg-white ">
    <div class="flex justify-between items-center w-full">
      <p class="w-full m-0 text-customBlue-100 font-roboto text-base">
        {{ $helper.formattedDate(item.sale_date) }}
      </p>
      <img :src="item.partner_company_logo" alt="Partner Company Logo" class="w-12 h-12 object-contain max-h-10">
    </div>
    <div
      class="relative grid grid-cols-4 tablet:grid-cols-5 laptop:grid-cols-12 largeDesktop:grid-cols-12 gap-2.5 laptop:gap-1.5 largeDesktop:gap-2.5 break-words">
      <div class="col-span-3 tablet:col-span-1 laptop:col-span-2 largeDesktop:col-span-1">
        <span class="text-[#999999] font-roboto text-base laptop:text-sm largeDesktop:text-base inline-block">Agreement
          ID:</span>
          <p class="m-0 font-roboto text-sm font-normal">
            {{ $helper.isEmpty(item.agreement_id) ? '-' : item.agreement_id }}
          </p>
        </div>
        <!-- status -->
        <!-- <div class="col-span-1 items-center justify-end mobile:flex tablet:hidden">
            <img :src="getStatusImage(item.status_slug)" alt="status-icon" class="w-5 h-5 mr-2.5">
        </div> -->
      <div class="col-span-4 tablet:col-span-1 laptop:col-span-1 largeDesktop:col-span-1">
        <span
          class="text-[#999999] font-roboto text-base laptop:text-sm largeDesktop:text-base inline-block">Consumer:</span>
        <p class="m-0 font-roboto text-sm font-normal">
          {{ $helper.isEmpty(item.consumer_name) ? '-' : item.consumer_name }}
        </p>
      </div>
      <div class="col-span-4 tablet:col-span-3 laptop:col-span-2 largeDesktop:col-span-3 relative group">
        <span class="text-[#999999] font-roboto text-base laptop:text-sm largeDesktop:text-base inline-block">
          Plan:
        </span>
        <!-- Show full name directly on mobile -->
        <p class="m-0 font-roboto text-sm font-normal block tablet:hidden">
          {{ item.plan_name }}
        </p>
        <!-- Short name + tooltip on tablet and above -->
        <p class="m-0 font-roboto text-sm font-normal relative hidden tablet:block">
          {{ getShortPlanName(item.plan_name) }}
          <span class="opacity-0 group-hover:!opacity-100 transition-opacity duration-300 max-w-[250px]
             absolute left-0 top-full mt-1 z-10 bg-white text-black text-sm
             px-2 py-1 rounded shadow-xl border border-gray-300">
            {{ item.plan_name }}
          </span>
        </p>
      </div>
      <div class="col-span-4 tablet:col-span-2 laptop:col-span-2 largeDesktop:col-span-2">
        <span
          class="text-[#999999] font-roboto text-base laptop:text-sm largeDesktop:text-base inline-block">Trade:</span>
        <p class="m-0 font-roboto text-sm font-normal">
          {{ $helper.isEmpty(item.trade_name) ? '-' : item.trade_name }}
        </p>
      </div>
      <div class="col-span-4 tablet:col-span-1 laptop:col-span-1 largeDesktop:col-span-1">
        <span class="text-[#999999] font-roboto text-base laptop:text-sm largeDesktop:text-base inline-block">Activation
          Date:</span>
        <p class="m-0 font-roboto text-sm font-normal">
          {{item.activation_date }}
        </p>
      </div>
      <div class="col-span-4 tablet:col-span-1 laptop:col-span-1 largeDesktop:col-span-1">
        <span class="text-[#999999] font-roboto text-base laptop:text-sm largeDesktop:text-base inline-block">Plan
          Amount:</span>
        <p class="m-0 font-roboto text-sm font-normal">
          ${{ $helper.isEmpty(item.total_amount) ? '-' : $helper.formatAmount(item.total_amount) }}
          <span class="mobile:text-base tablet:text-base">/{{
            item.payment_term_slug === 'yearly' ? 'yr' : 'mo'
          }}</span>
        </p>
      </div>
      <div class="col-span-4 tablet:col-span-1 laptop:col-span-1 largeDesktop:col-span-1 tablet:block">
        <div class="w-max">
          <span
            class="mobile:block text-[#999999] font-roboto text-base laptop:text-sm largeDesktop:text-base largeDesktop:font-roboto laptop:inline-block">Status: </span>
          <p v-if="item.status_slug == 'pending'"
            class="inline-block text-center py-[1px] px-[10px] text-sm rounded-[5px] mb-0 text-white bg-[#F39C12]">
            {{ item.status_text }}</p>
          <p v-else-if="item.status_slug == 'approved'"
            class="inline-block text-center py-[1px] px-[3px] text-sm rounded-[5px] mb-0 text-white bg-[#65B741]">
            {{ item.status_text }}</p>
          <p v-else-if="item.status_slug == 'payment_failed'"
            class="inline-block text-center py-[1px] px-[3px] text-sm rounded-[5px] mb-0 text-white bg-[#D7385E]">
            {{ item.status_text }}</p>
          <p v-else-if="item.status_slug == 'rejected'"
            class="inline-block text-center py-[1px] px-[15px] text-sm rounded-[5px] mb-0 text-white bg-[#D7385E]">
            {{ item.status_text }}</p>
          <p v-else-if="item.status_slug == 'active'"
            class="inline-block text-center py-[1px] px-[15px] text-sm rounded-[5px] mb-0 text-white bg-[#65B741] capitalize">
            {{ item.status_text }}</p>
            <p v-else-if="item.status_slug == 'cancelled'"
            class="inline-block text-center py-[1px] px-[15px] text-sm rounded-[5px] mb-0 text-white bg-[#D7385E] capitalize">
            {{ item.status_text }}</p>
          <p v-else>-</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  props: ["item"],
  components: {
  },
  methods: {
    getShortPlanName(name) {
      if (this.$helper.isEmpty(name)) return '-';
      return name.length > 30 ? name.substring(0, 30) + '...' : name;
    },
    getStatusImage(status) {
      switch (status) {
        case 'pending':
          return require('@/assets/images/pending-status.png');
        case 'approved':
          return require('@/assets/images/approved-green-icon.png');
        case 'rejected':
          return require('@/assets/images/reject-status.png');
        default:
          return require('@/assets/images/pending-status.png');
      }
    }
  }
};
</script>